import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import classes from './Breadcrumbs.module.css';
import { useBreadcrumbs } from './useBreadcrumbs';
import { BreadcrumbItem } from './BreadcrumbItem';
import { BreadcrumbSeparator } from './BreadcrumbSeparator';

const shouldShowBreadcrumbs = (breadcrumbsCount: number) => breadcrumbsCount > 1;

export const Breadcrumbs = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const breadcrumbs = useBreadcrumbs(pathname);

  if (!shouldShowBreadcrumbs(breadcrumbs.length)) {
    return null;
  }

  const lastIndex = breadcrumbs.length - 1;

  return (
    <nav aria-label={t('breadcrumbs.ariaLabel')} className={classes.breadcrumbs}>
      <ol className={classes.list}>
        {breadcrumbs.map((breadcrumb, index) => (
          <Fragment key={breadcrumb.path}>
            <BreadcrumbItem
              breadcrumb={breadcrumb}
              isCurrent={index === lastIndex}
            />
            {index < lastIndex && <BreadcrumbSeparator />}
          </Fragment>
        ))}
      </ol>
    </nav>
  );
};
